module.exports = __webpack_public_path__ + "img/responsive hospitium-12.be6de6e4.jpg";